import React from "react";


function Logo() {
    return (
        <a href="/" className="logo lg:w-[15%] md:w-4/12 sm:w-[20%]">
          <img
            src="/SB9 1.svg"
            alt="study buddy logo"
            className="w-full logo md:inline-block hidden"
            style={{ width: "100%", height: "100%" }}
          />
        </a>
      );
}

export default Logo
